import { render } from "./BooksView.vue?vue&type=template&id=3e8730f8"
import script from "./BooksView.vue?vue&type=script&lang=js"
export * from "./BooksView.vue?vue&type=script&lang=js"

import "./BooksView.vue?vue&type=style&index=0&id=3e8730f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__